module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Pretraga po:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nickname",
      "selected": ""
    }
  }, [_vm._v("Nickname")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "firstname"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lastname"
    }
  }, [_vm._v("Prezime")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "term"
    }
  }, [_vm._v("Traži")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "term",
      "placeholder": "Traži"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "keyup": function($event) {
        _vm.searchUser()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-results-list"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.userList), function(user) {
    return _c('li', {
      staticClass: "list-group-item",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.pickUser(user)
        }
      }
    }, [_vm._v(_vm._s(decodeURI(user.nickname)))])
  })), _vm._v(" "), (_vm.userList.length > 0 && _vm.selected_user == 0) ? _c('small', [_vm._v("Klikni na rezultat da odabereš igrača.")]) : _vm._e(), _vm._v(" "), (_vm.userList.length == 0 && _vm.term.length > 0) ? _c('p', [_vm._v("Nije pronađen igrač.")]) : _vm._e()])])]), _vm._v(" "), (_vm.selected_user > 0) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('p', [_vm._v("Nick: " + _vm._s(decodeURI(_vm.userInfo.nickname)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userInfo.email) + " " + _vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))]), _vm._v(" "), _c('p', [_vm._v("Coins: " + _vm._s(_vm.userInfo.coins))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.userInfo.id))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Razlog")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reason",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Broj zlatnika")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coins_number),
      expression: "coins_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "coins_number"
    },
    domProps: {
      "value": (_vm.coins_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coins_number = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', [_c('p', {
    staticClass: "text-danger text-right"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right",
    attrs: {
      "disabled": _vm.coins_number == 0,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addCoins()
      }
    }
  }, [_vm._v("\n                        Add Coins\n                      ")])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    staticClass: "table table-condensed table-striped"
  }, [_vm._m(2), _vm._v(" "), (_vm.transactions.length > 0) ? _c('tbody', _vm._l((_vm.transactions), function(transaction) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(decodeURI(transaction.nickname)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.coins_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.from_admin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.date))])])
  })) : _c('tbody', [_c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('h3', [_vm._v("\n            List is empty\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Highscores\n      "), _c('small', [_vm._v("All time")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Coin form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Coins")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f3432b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/coins/Rewards.vue
// module id = 315
// module chunks = 2